interface TabSubPanelProps {
  value: number;
  index: number;
  children: React.ReactNode;
}

/**
 * Pure visibility controller — renders children only when value === index.
 * All layout (header, save button) lives in TabSubPanelContent.
 */
export default function TabSubPanel({ value, index, children }: TabSubPanelProps) {
  return <>{value === index ? children : null}</>;
}
